import { forwardRef, useImperativeHandle } from 'react'
import type { Ref } from 'react'
import { View } from 'react-native'
import type {
  OpticalMeasureFreezeCommandResult,
  OpticalMeasureHSACaptureCommandResult,
  OpticalMeasurePointCommandResult,
  OpticalMeasureSHCaptureCommandResult,
  OpticalMeasureViewHandle,
  OpticalMeasureViewProps,
} from './ExpoOpticalMeasure.types'

const noFrameResult: OpticalMeasureFreezeCommandResult = {
  ok: false,
  reason: 'unsupported-platform',
  freeze: { active: false, source: 'live' },
}

const noPointResult: OpticalMeasurePointCommandResult = {
  ok: false,
  reason: 'unsupported-platform',
  freeze: { active: false, source: 'live' },
}

const unsupportedSHCaptureResult: OpticalMeasureSHCaptureCommandResult = {
  ok: false,
  reason: 'unsupported-platform',
  shCapture: {
    active: false,
    sessionId: 0,
    phase: 'idle',
    capturedCount: 0,
    targetCount: 1,
    source: 'vision',
  },
}

const unsupportedHSACaptureResult: OpticalMeasureHSACaptureCommandResult = {
  ok: false,
  reason: 'unsupported-platform',
  hsaCapture: {
    active: false,
    sessionId: 0,
    phase: 'idle',
    capturedCount: 0,
    targetCount: 1,
    progress: 0,
  },
}

function ExpoOpticalMeasureView(
  { style }: OpticalMeasureViewProps,
  ref: Ref<OpticalMeasureViewHandle>
) {
  useImperativeHandle(ref, () => ({
    freezeCurrentFrame: async () => noFrameResult,
    setLatestFreeze: async () => noFrameResult,
    clearFreeze: async () => ({
      ok: true,
      freeze: { active: false, source: 'live' },
    }),
    setRejectedFinalPreview: async () => noFrameResult,
    setPoint: async () => noPointResult,
    offsetPoint: async () => noPointResult,
    resetPoint: async () => noPointResult,
    rerunHSAFreeze: async () => noFrameResult,
    startSHCapture: async () => unsupportedSHCaptureResult,
    cancelSHCapture: async () => unsupportedSHCaptureResult,
    clearSHCapture: async () => unsupportedSHCaptureResult,
    startHSACapture: async () => unsupportedHSACaptureResult,
    cancelHSACapture: async () => unsupportedHSACaptureResult,
    clearHSACapture: async () => unsupportedHSACaptureResult,
  }))

  return <View style={[{ backgroundColor: 'black' }, style]} />
}

export default forwardRef(ExpoOpticalMeasureView)
